import React, { useState } from 'react';
import { Layout, Button, Drawer, Menu, Dropdown } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { HashLink } from 'react-router-hash-link';
import Logo from "../Assets/Brand/NcgsaLogo.png";
import "../Styles/HeaderStyles.css";
import { Link, NavLink } from 'react-router-dom';

const { Header } = Layout;
const { SubMenu } = Menu;

const AppHeader = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);

  // Show Drawer for mobile
  const showDrawer = () => {
    setDrawerVisible(true);
  };

  // Close Drawer
  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  // Anchor links for the dropdown menus
  const aboutMenu = (
    <Menu>
      <Menu.Item key="scientific-objectives">
        <HashLink smooth to="/about#scientific-objectives">Scientific Objectives</HashLink>
      </Menu.Item>
      <Menu.Item key="research-domains">
        <HashLink smooth to="/about#research-domains">Research Domains</HashLink>
      </Menu.Item>
      <Menu.Item key="partner-universities">
        <HashLink smooth to="/about#partner-universities">Partner Universities</HashLink>
      </Menu.Item>
      <Menu.Item key="national-steering-committee">
        <HashLink smooth to="/about#national-steering-committee">National Steering Committee</HashLink>
      </Menu.Item>
      <Menu.Item key="secretariat">
        <HashLink smooth to="/about#secretariat">Secretariat</HashLink>
      </Menu.Item>
    </Menu>
  );

  const researchLabsMenu = (
    <Menu>
      <Menu.Item key="sdssl">
        <Link to="/sdssl">Spatial Decision Support System Lab (SDSSL)</Link>
      </Menu.Item>
      <Menu.Item key="sarl">
        <Link to="/sarl">Space and Astrophysics Research Lab (SARL)</Link>
      </Menu.Item>
      <Menu.Item key="gserl">
        <Link to="/gserl">GNSS and Space Education Research Lab (GSERL)</Link>
      </Menu.Item>
      <Menu.Item key="sstrl">
        <Link to="/sstrl">Small Satellite Technology and Research Lab (SSTRL)</Link>
      </Menu.Item>
      <Menu.Item key="arsl">
        <Link to="/arsl">Agricultural Remote Sensing Lab (ARSL)</Link>
      </Menu.Item>
      <Menu.Item key="gsagl">
        <HashLink smooth to="/gsagl">GIS & Space Applications in Geosciences Lab (G-SAGL)</HashLink>
      </Menu.Item>
      <Menu.Item key="remote-sensing">
        <Link to="/rsgcrl">Remote Sensing, GIS and Climatic Research Lab</Link>
      </Menu.Item>
    </Menu>
  );

  const linkagesMenu = (
    <Menu>
      <Menu.Item key="latest-updates">
        <HashLink smooth to="/linkages#latest-updates">Latest Updates</HashLink>
      </Menu.Item>
      <SubMenu
        key="space-awareness-outreach"
        title={(
          <Link className="submenu-overview-link" to="/events" onClick={(event) => event.stopPropagation()}>
            Space Awareness &amp; Outreach
          </Link>
        )}
      >
        <Menu.Item key="space-summer-school">
          <Link to="/space-summer-school">Space Summer School</Link>
        </Menu.Item>
        <Menu.Item key="world-space-week">
          <Link to="/world-space-week">World Space Week</Link>
        </Menu.Item>
        <Menu.Item key="astronomy-outreach">
          <HashLink smooth to="/astronomy-outreach">Astronomy Outreach</HashLink>
        </Menu.Item>
        <Menu.Item key="student-satellite-outreach">
          <Link to="/student-satellite-outreach">Student Satellite Outreach</Link>
        </Menu.Item>
        <Menu.Item key="space-destination-schools">
          <Link to="/space-destination-schools">Space Destination Schools</Link>
        </Menu.Item>
        <Menu.Item key="space-outreach-telefilm">
          <Link to="/space-outreach-film">Space Outreach Film</Link>
        </Menu.Item>
      </SubMenu>
      <Menu.Item key="capacity-building-forums">
        <Link to="/capacity-building-workshops-forums">Capacity Building Workshops &amp; Forums</Link>
      </Menu.Item>
      <SubMenu
        key="international-conferences"
        title={(
          <Link className="submenu-overview-link" to="/international-conferences" onClick={(event) => event.stopPropagation()}>
            International Conferences
          </Link>
        )}
      >
        <Menu.Item key="icast-2025">
          <Link to="/icast-2025">ICAST 2025</Link>
        </Menu.Item>
        <Menu.Item key="icase">
          <Link to="/icase">ICASE</Link>
        </Menu.Item>
      </SubMenu>
      <Menu.Item key="collaborations">
        <Link to="/collaborations">Collaborations</Link>
      </Menu.Item>
    </Menu>
  );

  const opportunitiesMenu = (
    <Menu>
      <Menu.Item key="internships">
        <HashLink smooth to="/opportunities#internships">Internships</HashLink>
      </Menu.Item>
      <Menu.Item key="collab-us">
        <HashLink smooth to="/opportunities#collaborate-with-us">Collaborate with us</HashLink>
      </Menu.Item>
    </Menu>
  );

  return (
    <Header className="header">
      <div className="logo">
       <Link to="/">
       <img src={Logo} alt="National Center of GIS and Space Applications" />
       </Link>
      </div>

      {/* Inline Navigation Links for large screens */}
      <div className="inline-nav">
        <NavLink to="/" end>Home</NavLink>
        <Dropdown overlay={aboutMenu} trigger={['hover']}>
          <NavLink to="/about" className="nav-link">
            About NCGSA
          </NavLink>
        </Dropdown>
        <Dropdown overlay={researchLabsMenu} trigger={['hover']}>
          <NavLink to="/research-labs">Research Labs</NavLink>
        </Dropdown>
        <Dropdown overlay={linkagesMenu} trigger={['hover']}>
          <NavLink to="/linkages">Linkages and Capacity Building</NavLink>
        </Dropdown>
        <HashLink smooth to="/research-fund">Research Fund</HashLink>
        <Dropdown overlay={opportunitiesMenu} trigger={['hover']}>
          <NavLink to="/opportunities">Opportunities</NavLink>
        </Dropdown>
        <NavLink to="/contact">Contact</NavLink>
      </div>

      {/* Mobile Drawer Button */}
      <Button className="menu-button" icon={<MenuOutlined />} onClick={showDrawer} />

      {/* Mobile Drawer */}
      <Drawer
        title="NCGSA Menu"
        placement="right"
        onClose={closeDrawer}
        open={drawerVisible}
      >
        <Menu mode="inline">
          {/* About NCGSA */}
          <SubMenu key="drawer-about" title="About NCGSA">
            <Menu.Item key="drawer-scientific-objectives">
              <HashLink smooth to="/about#scientific-objectives" onClick={closeDrawer}>
                Scientific Objectives
              </HashLink>
            </Menu.Item>
            <Menu.Item key="drawer-research-domains">
              <HashLink smooth to="/about#research-domains" onClick={closeDrawer}>
                Research Domains
              </HashLink>
            </Menu.Item>
            <Menu.Item key="drawer-partner-universities">
              <HashLink smooth to="/about#partner-universities" onClick={closeDrawer}>
                Partner Universities
              </HashLink>
            </Menu.Item>
            <Menu.Item key="drawer-national-steering-committee">
              <HashLink smooth to="/about#national-steering-committee" onClick={closeDrawer}>
                National Steering Committee
              </HashLink>
            </Menu.Item>
            <Menu.Item key="drawer-secretariat">
              <HashLink smooth to="/about#secretariat" onClick={closeDrawer}>
                Secretariat
              </HashLink>
            </Menu.Item>
          </SubMenu>

          {/* Research Labs */}
          <SubMenu key="drawer-research-labs" title="Research Labs">
              <Menu.Item key="drawer-research-labs-overview">
                <Link to="/research-labs" onClick={closeDrawer}>
                  Research Labs Overview
                </Link>
              </Menu.Item>
              <Menu.Item key="drawer-sdssl">
                <Link to="/sdssl" onClick={closeDrawer}>
                  Spatial Decision Support System Lab (SDSSL)
                </Link>
              </Menu.Item>
              <Menu.Item key="drawer-sarl">
                <Link to="/sarl" onClick={closeDrawer}>
                  Space and Astrophysics Research Lab (SARL)
                </Link>
              </Menu.Item>
              <Menu.Item key="drawer-gserl">
                <Link to="/gserl" onClick={closeDrawer}>
                  GNSS and Space Education Research Lab (GSERL)
                </Link>
              </Menu.Item>
              <Menu.Item key="drawer-sstrl">
                <Link to="/sstrl" onClick={closeDrawer}>
                  Small Satellite Technology and Research Lab (SSTRL)
                </Link>
              </Menu.Item>
              <Menu.Item key="drawer-arsl">
                <Link to="/arsl" onClick={closeDrawer}>
                  Agricultural Remote Sensing Lab (ARSL)
                </Link>
              </Menu.Item>
              <Menu.Item key="drawer-gis-sagl">
                <Link to="/gsagl" onClick={closeDrawer}>
                  GIS & Space Applications in Geosciences Lab (G-SAGL)
                </Link>
              </Menu.Item>
              <Menu.Item key="drawer-remote-sensing">
                <Link to="/rsgcrl" onClick={closeDrawer}>
                  Remote Sensing, GIS and Climatic Research Lab
                </Link>
              </Menu.Item>
          </SubMenu>

          {/* Linkages and Capacity Building */}
          <SubMenu key="drawer-linkages" title="Linkages and Capacity Building">
            <Menu.Item key="drawer-latest-updates">
              <HashLink smooth to="/linkages#latest-updates" onClick={closeDrawer}>
                Latest Updates
              </HashLink>
            </Menu.Item>
            <SubMenu key="drawer-space-awareness-outreach" title="Space Awareness & Outreach">
              <Menu.Item key="drawer-space-awareness-overview">
                <Link to="/events" onClick={closeDrawer}>Space Awareness &amp; Outreach Overview</Link>
              </Menu.Item>
              <Menu.Item key="drawer-space-summer-school">
                <Link to="/space-summer-school" onClick={closeDrawer}>Space Summer School</Link>
              </Menu.Item>
              <Menu.Item key="drawer-world-space-week">
                <Link to="/world-space-week" onClick={closeDrawer}>World Space Week</Link>
              </Menu.Item>
              <Menu.Item key="drawer-astronomy-outreach">
                <HashLink smooth to="/astronomy-outreach" onClick={closeDrawer}>Astronomy Outreach</HashLink>
              </Menu.Item>
              <Menu.Item key="drawer-student-satellite-outreach">
                <Link to="/student-satellite-outreach" onClick={closeDrawer}>Student Satellite Outreach</Link>
              </Menu.Item>
              <Menu.Item key="drawer-space-destination-schools">
                <Link to="/space-destination-schools" onClick={closeDrawer}>Space Destination Schools</Link>
              </Menu.Item>
              <Menu.Item key="drawer-space-outreach-telefilm">
                <Link to="/space-outreach-film" onClick={closeDrawer}>Space Outreach Film</Link>
              </Menu.Item>
            </SubMenu>
            <Menu.Item key="drawer-capacity-building-forums">
              <Link to="/capacity-building-workshops-forums" onClick={closeDrawer}>
                Capacity Building Workshops &amp; Forums
              </Link>
            </Menu.Item>
            <SubMenu key="drawer-international-conferences" title="International Conferences">
              <Menu.Item key="drawer-international-conferences-overview">
                <Link to="/international-conferences" onClick={closeDrawer}>International Conferences Overview</Link>
              </Menu.Item>
              <Menu.Item key="drawer-icast-2025">
                <Link to="/icast-2025" onClick={closeDrawer}>ICAST 2025</Link>
              </Menu.Item>
              <Menu.Item key="drawer-icase">
                <Link to="/icase" onClick={closeDrawer}>ICASE</Link>
              </Menu.Item>
            </SubMenu>
            <Menu.Item key="drawer-collaborations">
              <Link to="/collaborations" onClick={closeDrawer}>
                Collaborations
              </Link>
            </Menu.Item>
          </SubMenu>

          {/* World Space Week 2024 */}
          <Menu.Item key="drawer-space-week">
            <HashLink smooth to="/world-space-week" onClick={closeDrawer}>
              World Space Week 2024
            </HashLink>
          </Menu.Item>

          {/* Opportunities */}
          <SubMenu key="drawer-opportunities" title="Opportunities">
            <Menu.Item key="drawer-opportunities-internships">
              <HashLink smooth to="/opportunities#internships" onClick={closeDrawer}>
                Internships
              </HashLink>
            </Menu.Item>
            <Menu.Item key="drawer-collab-us">
              <HashLink smooth to="/opportunities#collaborate-with-us" onClick={closeDrawer}>
                Collaborate with us
              </HashLink>
            </Menu.Item>
          </SubMenu>

          {/* Contact */}
          <Menu.Item key="drawer-contact">
            <HashLink smooth to="/contact" onClick={closeDrawer}>
              Contact
            </HashLink>
          </Menu.Item>
        </Menu>
      </Drawer>
    </Header>
  );
};

export default AppHeader;
